import {
  Controller,
  type FieldValues,
  type Path,
  type UseFormReturn,
} from "react-hook-form";

import { Text } from "@alpacahq/ui/old";

import { CountryCombobox } from "~/v2/components/form";
import type { Country } from "~/v2/types";

interface EntityCountryFieldProps<T extends FieldValues> {
  isRequired: boolean;
  isInvalid: boolean;
  errorMsg?: string;
  label: string;
  name: Path<T>;
  control: UseFormReturn<T>["control"];
  countries: Country[];
  placeholder: string;
}

export const EntityCountryField = <T extends FieldValues>({
  isRequired,
  isInvalid,
  errorMsg,
  label,
  name,
  control,
  countries,
  placeholder,
}: EntityCountryFieldProps<T>) => (
  <Controller<T>
    name={name}
    control={control}
    rules={{ required: isRequired }}
    render={({ field: { onChange, value, name } }) => (
      <div className="flex flex-col gap-2">
        <label
          htmlFor={name}
          className="block font-medium text-gray-900 text-md leading-6 dark:text-gray-100"
        >
          {label}
        </label>
        <CountryCombobox
          name={name}
          items={countries}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          status={isInvalid ? "error" : "neutral"}
        />
        {isInvalid && errorMsg && (
          <Text className="truncate text-rose-500 text-xs">{errorMsg}</Text>
        )}
      </div>
    )}
  />
);
